module.exports = __webpack_public_path__ + "assets/img/station30.af4991eb.png";